import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Check } from 'lucide-react';

const CheckItem = ({ children }) => (
  <li className="flex items-start gap-2">
    <Check className="w-4 h-4 text-[#2F424D] mt-0.5 flex-shrink-0" strokeWidth={2.5} />
    <span>{children}</span>
  </li>
);

const InfoNote = ({ children }) => (
  <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 mt-4">
    <p className="text-xs text-gray-600">{children}</p>
  </div>
);

export function InstallModal0({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md max-h-[85vh] overflow-y-auto bg-white rounded-xl">
        <DialogHeader>
          <DialogTitle className="text-gray-900 text-lg">Ingen installation</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm text-gray-700">
          <p>Ladeboksen leveres til din adresse. Du bestiller selv en autoriseret elektriker til installation – fx hvis du allerede har et aftalt el-firma.</p>
          <ul className="space-y-2.5">
            <CheckItem>Ladeboksen sendes til din adresse</CheckItem>
            <CheckItem>Du bestiller selv autoriseret el-installatør</CheckItem>
            <CheckItem>Kræver lovpligtigt autorisation – kan ikke udføres af ikke-autoriserede</CheckItem>
            <CheckItem>Velegnet hvis du allerede har et el-firma tilknyttet</CheckItem>
            <CheckItem>Installationsvejledning medfølger</CheckItem>
          </ul>
          <button onClick={() => onClose(false)} className="w-full mt-2 py-3 rounded-xl bg-gray-100 hover:bg-gray-200 text-sm font-semibold text-gray-700 transition-colors">Luk</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function InstallModal1({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md max-h-[85vh] overflow-y-auto bg-white rounded-xl">
        <DialogHeader>
          <DialogTitle className="text-gray-900 text-lg">Eksisterende installation</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm text-gray-700">
          <p>Vores autoriserede elektriker tilslutter ladeboksen til et eksisterende kraftstik eller stikdåse.</p>
          <ul className="space-y-2.5">
            <CheckItem>Tilslutning til eksisterende 3-faset kraftstik (16A/32A)</CheckItem>
            <CheckItem>Opsætning og konfiguration af ladeboks</CheckItem>
            <CheckItem>Test af installation og funktionalitet</CheckItem>
            <CheckItem>Gennemgang af app og Saving Mode opsætning</CheckItem>
          </ul>
          <InfoNote><strong>Velegnet hvis:</strong> Du allerede har et 3-faset kraftstik (rød stikdåse) eller forberedt el til ladeboks inden for 2 meter.</InfoNote>
          <button onClick={() => onClose(false)} className="w-full mt-2 py-3 rounded-xl bg-gray-100 hover:bg-gray-200 text-sm font-semibold text-gray-700 transition-colors">Luk</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function InstallModal2({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md max-h-[85vh] overflow-y-auto bg-white rounded-xl">
        <DialogHeader>
          <DialogTitle className="text-gray-900 text-lg">Standard installation</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm text-gray-700">
          <p>Komplet installation med nyt kabel fra eltavle til ladeboks – op til 10 meter.</p>
          <ul className="space-y-2.5">
            <CheckItem>Nyt 5x6mm² kabel fra eltavle (op til 10m)</CheckItem>
            <CheckItem>Installation af ny gruppe i eltavle med HPFI</CheckItem>
            <CheckItem>Montering af ladeboks på væg</CheckItem>
            <CheckItem>Kabelkanal eller rør til kabelføring inkluderet</CheckItem>
            <CheckItem>Test, dokumentation og elinstallationsrapport</CheckItem>
            <CheckItem>Gennemgang af app og Saving Mode opsætning</CheckItem>
          </ul>
          <InfoNote><strong>Bemærk:</strong> Ved kabelføring over 10 meter, særlige bygningsforhold, eller behov for udvidelse af eltavle, kan der tillægges ekstra. Elektrikeren kontakter dig inden installation.</InfoNote>
          <button onClick={() => onClose(false)} className="w-full mt-2 py-3 rounded-xl bg-gray-100 hover:bg-gray-200 text-sm font-semibold text-gray-700 transition-colors">Luk</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}